import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";

const ImagePlaceholder = () => (
  <ContentLoader
    speed={2}
    width={400}
    height={200}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" rx="10" ry="10" width="400" height="200" />
  </ContentLoader>
);

export default ImagePlaceholder;